import { MessageStatus } from "../../../../shared/api";
import { FSMStages } from "../../../../shared/model";
export var getMessageStatus = function getMessageStatus(stage, isOnline, zoneType) {
  return zoneType === 'unauthorized' && stage === FSMStages.CAPTCHA_NEEDED && isOnline ? MessageStatus.delivered : MessageStatus.sent;
};